import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import {
  NgbDateAdapter,
  NgbDateNativeAdapter
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
})
export class LoanComponent {
  @Input()
  form: FormGroup;
  faCalendarAlt = faCalendarAlt;

  get loanAmount() {
    return this.form.get('loan.loanAmount') as FormControl;
  }

  get purchasePrice() {
    return this.form.get('loan.purchasePrice') as FormControl;
  }
}
